import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class LogExecucaoColetaService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'log-execucao-coleta');
  }

  // Listar com filtros
  listar(filtros: any): Observable<any> {
    let params = new HttpParams();
    
    if (filtros.estacao_id) {
      params = params.set('estacao_id', filtros.estacao_id);
    }
    if (filtros.configuracao_coleta_id) {
      params = params.set('configuracao_coleta_id', filtros.configuracao_coleta_id);
    }
    if (filtros.status_code) {
      params = params.set('status_code', filtros.status_code);
    }
    if (filtros.data_inicio) {
      params = params.set('data_inicio', filtros.data_inicio);
    }
    if (filtros.data_fim) {
      params = params.set('data_fim', filtros.data_fim);
    }

    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

}

